// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1CHSm","content":"ManualTimeModal_content__2JQ_j"};